import { FaCloud, FaCogs, FaEye, FaMicrochip, FaNetworkWired } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import dcImg from "../assets/iotdc.jpg";
import mfImg from "../assets/iotman.png";
import voneImg from "../assets/iotfour.jpg";
import iotfImg from "../assets/iotfive.jpg";
import sbImg from "../assets/sb.jpg";
import scImg from "../assets/iotsecurity.jpg";
import { default as bgImage } from "../assets/IotOne.jpg";

function IctIot() {
     const navigate = useNavigate();

    const focusAreas = [
        {
            icon: <FaNetworkWired />,
            title: "Networking & Infrastructure",

        },
        {
            icon: <FaMicrochip />,
            title: "IoT Device Integration",

        },
        {
            icon: <FaEye />,
            title: "Smart Monitoring Solutions",

        },
        {
            icon: <FaCloud />,
            title: "Cloud & Data Management",

        },
        {
            icon: <FaCogs />,
            title: "Automation Systems",

        }
    ];

    const solutions = [
        {
            title: "Manufacturing",
            desc: "Machine monitoring, predictive maintenance, and process automation.",
            img: mfImg,
        },
        {
            title: "Data Centers",
            desc: "Environmental and power monitoring to ensure uptime and safety.",
            img: dcImg,
        },
        {
            title: "Smart Buildings",
            desc: "Energy efficiency, climate control, and intelligent lighting systems.",
            img: sbImg,
        },
        {
            title: "Security",
            desc: "CCTV surveillance, access control, and intrusion detection systems.",
            img: scImg,
        },
    ];



    return (
        <section className="w-full  " id="ict-iot">

            {/* Title */}
            <div
                className="w-full relative h-[40vh] text-white py-20 px-6 text-center bg-cover bg-center"
                style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="items-center border-4  max-w-4xl m-auto justify-start p-8 rounded-lg shadow-lg">
                    <h2 className="text-[32px] font-bold text-white mb-4">
                        ICT & IoT Services
                    </h2>
                    <p
                        className="text-white max-w-2xl mx-auto transition-opacity duration-700 ease-in-out"

                    >
                        Innovating with cutting-edge IoT technology to optimize operations and boost efficiency
                    </p>
                </div>
            </div>

            <section className="w-full py-16 px-6 md:px-24 bg-white">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12">
                    <div className="grid grid-cols-2 gap-4">

                        <div>
                            <img
                                src={voneImg}
                                alt="ICT and IoT"
                                className="w-full h-full object-cover rounded-lg"
                                style={{ height: "100%" }}
                            />
                        </div>


                        <div className="flex flex-col gap-4">
                            <img
                                src={iotfImg}
                                alt="ICT and IoT"
                                className="w-full h-1/2 object-cover rounded-lg"
                                style={{ height: "50%" }}
                            />
                            <img
                                src={sbImg}
                                alt="ICT and IoT"
                                className="w-full h-1/2 object-cover rounded-lg"
                                style={{ height: "50%" }}
                            />
                        </div>

                    </div>

                    {/* Right Text */}
                    <div className="">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
                            Transforming Spaces with Excellence
                        </h2>
                        <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
                            We are committed to delivering exceptional results in every project we take on.
                            Our team combines innovative design, quality craftsmanship, and sustainable practices
                            to bring your vision to life. Whether it’s residential, commercial, or industrial,
                            we ensure every detail meets the highest standards of excellence.
                        </p>
                    </div>
                </div>
            </section>


            <section className=" py-16 px-6 md:px-24 bg-gray-950">
                <div className="flex max-w-6xl  flex-col items-center gap-12">
                    {/* Section Heading */}
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-snug">Key Focus Areas</h2>

                    {/* Cards */}
                    <div className="grid sm:grid-cols-2  gap-8 w-full max-w-6xl">
                        {focusAreas.map((item, index) => (
                            <div
                                key={index}
                                className="relative border border-orange-500 rounded-lg p-6 pt-12 text-center shadow-sm hover:shadow-lg transition-shadow duration-300"
                            >

                                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-white text-orange-600 rounded-full flex items-center justify-center text-2xl shadow-md">
                                    {item.icon}
                                </div>

                                {/* Title */}
                                <h3 className="font-semibold text-lg mb-2 text-white">{item.title}</h3>

                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="w-full py-16 px-4 sm:px-6 md:px-24 bg-white">
                <div className="max-w-7xl mx-auto text-center mb-12 px-4">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
                        Applications of Our ICT & IoT Services
                    </h2>
                    <p className="text-gray-600 max-w-3xl mx-auto mt-4">
                        Our solutions are designed to solve practical challenges across various industries:
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-7xl mx-auto px-4">
                    {solutions.map(({ title, desc, img }, idx) => (
                        <div
                            key={idx}
                            className="relative rounded-lg overflow-hidden border border-gray-300 shadow-md cursor-pointer group"
                            tabIndex={0}
                        >
                            <img
                                src={img}
                                alt={title}
                                className="w-full h-56 sm:h-64 md:h-72 object-cover transition-transform duration-300 group-hover:scale-110 group-hover:opacity-100 opacity-70"
                                loading="lazy"
                            />
                            
                            <div className="absolute top-0 left-0 right-0 bg-black bg-opacity-60  px-4 py-2 text-white font-semibold text-lg sm:text-xl md:text-2xl">
                                {title}
                            </div>
                            
                            <div className="absolute inset-0 bg-black bg-opacity-85 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-start pt-16 px-6 sm:px-10 text-left">
                                <h3 className="text-white text-xl md:text-2xl font-semibold mb-4">{title}</h3>
                                <p className="text-gray-300 text-sm sm:text-base md:text-lg mb-6">{desc}</p>
                               
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            <section className="w-full bg-orange-500 py-12 px-6 md:px-24 text-center rounded-lg shadow-lg mb-36">
                <h2 className="text-3xl font-bold text-white mb-4">
                    Ready to Take Your Project to the Next Level?
                </h2>
                <p className="text-white mb-6 max-w-xl mx-auto">
                    Book a consultation or request a proposal today — let’s build something amazing together!
                </p>
                <button onClick={() => navigate("/contact")} className="bg-white text-orange-500 font-semibold px-6 py-3 rounded-md hover:bg-gray-100 transition">
                    Get Started
                </button>
            </section>


        </section>
    );
}



export default IctIot